__turbopack_context__.v({
  "image": "BoardSectionError-module-scss-module__d0yg1q__image",
  "title": "BoardSectionError-module-scss-module__d0yg1q__title",
});
